export default "__VITE_ASSET__Nf10$hg9__"